"use client";

import BackToTop from "@/components/theme/common/BackToTop";
import MobileMenu from "@/components/theme/headers/MobileMenu";
import { closeMenu } from "@/components/theme/toggleMenu";
import { usePathname } from "next/navigation";
import "photoswipe/dist/photoswipe.css";
import { useEffect } from "react";
import sal from "sal.js";
import "../../../../public/assets/scss/main.scss";

export default function RootLayout({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    if (typeof window !== "undefined") {
      // Import the script only on the client side
      import("bootstrap/dist/js/bootstrap.esm" as any).then(() => {
        // Module is imported, you can access any exported functionality if
      });
      // setTimeout(() => {
      //   import("../utlis/mmenu").then(() => {
      //     // Module is imported, you can access any exported functionality if
      //     new window.Mmenu(document.querySelector("#menu"));
      //   });
      // }, 200);
    }
  }, []);

  const pathname = usePathname();
  useEffect(() => {
    sal({
      root: null,
      threshold: 0.01,
      once: true,
    });
  }, [pathname]);
  useEffect(() => {
    // Close any open modal
    closeMenu();
  }, [pathname]);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 250) {
        document.querySelector(".header-sticky")?.classList.add("sticky");
      } else {
        document.querySelector(".header-sticky")?.classList.remove("sticky");
      }
    };

    // Add scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Cleanup function to remove the scroll event listener
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const isDarkmode = localStorage.getItem("isDarkmode");

    // Compare to the string "true"
    if (isDarkmode === "true") {
      document.body.setAttribute("class", "active-dark-mode");
    } else if (isDarkmode === "false") {
      document.body.setAttribute("class", "active-light-mode");
    }
  }, []);

  return (
    <>
      {children}
      <MobileMenu />
      <BackToTop />
    </>
  );
}
